import { StyleSheet } from "react-native";
const PropertiesStyle = StyleSheet.create({
  titleToggle: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 20,
  },

  summaryContainer: {
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 10,
    marginBottom: 16,
  },

  switchContainer: {
    flexDirection: "row",
    alignItems: "center",
  },

  entypoIconContainer: {
    alignSelf: "flex-end",
    marginTop: 10,
    paddingHorizontal: 16,
  },

  mapContainer: {
    flex: 1,
    height: "100%",
  },

  scrollContainer: {
    padding: 8,
  },

  expandedDetails: {
    paddingLeft: 16,
  },

  row: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
});

export default PropertiesStyle;
